<template>
	<div>
		<div class="create-container">
			<div class="terms-header">
				<div class="row" style="margin-top: 25px;">
					<div class="col-md-12 xs-text-center">
						<img v-if="logoSrc" :src="logoSrc" style="width:250px;" />
						<h3><strong>{{ districtName }}</strong></h3>
					</div>

					<div class="col-md-12 user-agreement-label">
						<h3 class="xs-text-center">
							Sapphire Community Portal User Agreement
						</h3>
					</div>
				</div>
			</div>
			<div class="terms-cond" v-html="userPolicy"></div>
			<form method="post" ref="form" @submit.prevent="validateBeforeSubmit" :action="postEndpoint">
				<input type="hidden" name="_csrftoken" :value="csrfToken" />
				<div class="form-group"  :class="{'has-warning': errors.has('username') }">
					<div class="input-terms" v-if="allowStudentApplications == 'Y'">
						<label for="account_type">
							Select the type of account you are applying for:
						</label>
						<select class="form-control" name="account_type">
							<option value="parent">
								Parent Account
							</option>
							<option value="student">
								Student Account
							</option>
						</select>
					</div>
					<div class="input-terms" :class="{'has-warning': errors.has('keyword') }">
						<label>
							<input class="radio-btn"
										 name="accepted"
										 v-model="useraccepts"
										 value="accepts"
										 type="checkbox"
										 true-value="accepts"
										 false-value="no">
							I have read and agree to the above policies
						</label>
					</div>
				</div>
				<div>
					<button type="submit" class="btn btn-block btn-primary"
									:disabled="useraccepts==='no'">
						Continue
					</button>
					<div class="go-back">
						<a :href="entrypoint"><i class="fas fa-chevron-left"></i> Go Back</a>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TermsAgreement',
		props: {
			districtName : "",
			logoSrc : "",
			csrfToken : "",
			entrypoint : {
				type: String,
				required: true
			},
			postEndpoint : {
				type: String,
				required: true
			},
			userPolicy : {
				type: String,
				required: true
			},
			allowStudentApplications : {
				type: String,
				required: true
			}
		},
		data() {
			return {useraccepts: "no",}
		},
		computed: {
			isFormInvalid() {
				return Object.keys(this.fields).some(key => this.fields[key].invalid);
			},
			isFormTouched() {
				return Object.keys(this.fields).some(key => this.fields[key].touched);
			},
			getMessageClass() {
				return "alert alert-" + this.getActiveMessage.category;
			},
			getActiveMessage() {
				if(this.isFormInvalid && this.isFormTouched) {
					return {
						category: "warning",
						content: "Some required fields are missing!"
					}
				} else {
					return this.message;
				}
			}
		},
		methods: {
			validateBeforeSubmit() {
				this.$validator.validateAll().then((result) => {
					if(result) {
						this.$refs.form.submit();
						return;
					}
				});
			}
		}
	}
</script>
